<template>
  <v-app>
    <table class="mt-2">
      <tr>
        <th class="small-cell">نام محصول</th>
        <th class="small-cell">تصویر</th>
        <th class="small-cell">نامک</th>
        <th class="mid-cell">ابزار</th>
      </tr>
      <a-product
        @slugMe="openSlugModal"
        v-for="(p, i) in theShop.products"
        :key="i"
        :theProduct="p"
      ></a-product>
    </table>
    <div class="modal" id="slugModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="p-3 d-flex justify-content-between">
            <h5 class="modal-title">افزودن و تغییر سئو</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-text-field
              label="عنوان سئو"
              v-model="productSlug.title_seo.value"
              outlined
              dense
              @keyup.enter="addSlug()"
            ></v-text-field>

            <v-text-field
              label="نامک"
              v-model="productSlug.slug.value"
              outlined
              dense
              @keyup.enter="addSlug()"
            ></v-text-field>

            <v-text-field
              label="ادیتور"
              v-model="productSlug.editor.value"
              outlined
              dense
              @keyup.enter="addSlug()"
            ></v-text-field>
            <v-text-field
              label="توضیحات متا"
              v-model="productSlug.meta_desc.value"
              outlined
              dense
              @keyup.enter="addSlug()"
            ></v-text-field>
            <!--             
            <custom-input
              kind="text"
              key="14"
              container="full-width ml-3 mt-3"
              classes="full-width"
              v-bind:theModel.sync="productSlug.meta_desc"
              label="توضیحات متا"
              @keyup.enter="addSlug()"
            ></custom-input> -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="addSlug()">
              <span v-if="!loading"> ثبت تغییرات</span>
              <span v-if="loading" class="mr-2"
                ><v-progress-circular
                  :size="20"
                  color="white"
                  indeterminate
                ></v-progress-circular
              ></span>
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import AProduct from "./partials/AProduct.vue";
import { computed, inject, onMounted, ref } from "@vue/composition-api";
import Service from "../../../utils/admin-service";
import CustomInput from "../../Common/CustomInput";
import $ from "jquery";
export default {
  components: {
    AProduct,
    CustomInput,
  },
  setup(props, context) {
    const global = inject("global");

    const loading = ref(false);
    const theService = computed(() => {
      return Service(false);
    });
    const authService = computed(() => {
      return Service(true);
    });
    const theShop = ref([]);
    onMounted(() => {
      theService.value.receive(
        "search/seller/" + context.root.$route.params.id,
        {},
        (s, d) => {
          if (s == 200) {
            theShop.value = d.data;
          }
        }
      );
    });
    const get_seo = function () {
      loading.value = true;
      authService.value.receive(
        "admin/seo/product/" + productSlugId.value,
        {},
        (s, data) => {
          if (s == 200) {
            loading.value = false;
            store_slug.value = data;
            productSlug.value.slug.value = data.data.slug;
            productSlug.value.editor.value = data.data.editor;
            productSlug.value.title_seo.value = data.data.title_seo;
            productSlug.value.meta_desc.value = data.data.meta_desc;
            console.log("data");
          }
        }
      );
    };
    const store_slug = ref({});

    const productSlugId = ref(null);
    const openSlugModal = (i) => {
      loading.value = true;
      productSlugId.value = i;
      $("#slugModal").modal("show");
      get_seo();
    };
    const addSlug = () => {
      loading.value = true;
      let f = new FormData();
      if (store_slug.value.slug != productSlug.value.slug.value)
        f.append("slug", productSlug.value.slug.value);
      if (store_slug.value.editor != productSlug.value.editor.value)
        f.append("editor", productSlug.value.editor.value);
      if (store_slug.value.title_seo != productSlug.value.title_seo.value)
        f.append("title_seo", productSlug.value.title_seo.value);
      if (store_slug.value.meta_desc != productSlug.value.meta_desc.value)
        f.append("meta_desc", productSlug.value.meta_desc.value);
      authService.value.transmit(
        "admin/seo/product/" + productSlugId.value,
        f,
        (s, d) => {
          if (s == 200) {
            global.alertToggle("با موفقیت افزوده شد!");
            loading.value = false;
            $("#slugModal").modal("toggle");
          }
        }
      );
    };

    const productSlug = ref({
      seo: { value: null, valid: true },
      slug: { value: null, valid: true },
      editor: { value: null, valid: true },
      title_seo: { value: null, valid: true },
      meta_desc: { value: null, valid: true },
      image: null,
    });
    return {
      authService,
      theShop,
      openSlugModal,
      addSlug,
      productSlug,
      get_seo,
      store_slug,
      loading,
    };
  },
};
</script>
<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  table-layout: fixed;
  text-align: center;
}

td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding-right: 1rem;
}

tr {
  width: 100%;
}

.big-cell {
  width: 75%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.mid-cell {
  max-width: 12.5%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.small-cell {
  max-width: 10%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.modal-footer {
  color: #fff;
  border-top: none;
}
</style>